import { render, staticRenderFns } from "./AddBanner.vue?vue&type=template&id=c407b616&scoped=true&"
import script from "./AddBanner.vue?vue&type=script&lang=js&"
export * from "./AddBanner.vue?vue&type=script&lang=js&"
import style0 from "./AddBanner.vue?vue&type=style&index=0&id=c407b616&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c407b616",
  null
  
)

export default component.exports